import { useState } from "react";
import { toast } from "sonner";
import { Loader2, MailCheck, KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Section } from "@/components/settings/SettingsSections";
import { api, formatApiError } from "@/lib/api";

export const TestEmailCard = ({ configured }) => {
  const [to, setTo] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try { await api.post("/settings/test-email", { to }); toast.success(`Email di prova inviata a ${to}`); }
    catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };
  return (
    <Section title="Verifica invio" testId="test-email-card" hint={configured ? "Salva le impostazioni, poi invia una prova." : "Configura e salva prima l'SMTP."}>
      <Input type="email" placeholder="tua@email.it" value={to} onChange={(e) => setTo(e.target.value)} data-testid="test-email-input" />
      <Button variant="outline" className="w-full" onClick={send} disabled={busy || !to} data-testid="smtp-test-button">
        {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <MailCheck className="mr-2 h-4 w-4" />} Invia email di prova
      </Button>
    </Section>
  );
};

export const PasswordCard = () => {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Password di accesso aggiornata");
      setCur(""); setNext("");
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };
  return (
    <Section title="Password di accesso" testId="change-password-card" hint="Minimo 8 caratteri.">
      <Input type="password" placeholder="Password attuale" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="current-password-input" />
      <Input type="password" placeholder="Nuova password" value={next} onChange={(e) => setNext(e.target.value)} data-testid="new-password-input" />
      <Button variant="outline" className="w-full" onClick={submit} disabled={busy || !cur || next.length < 8} data-testid="change-password-button">
        {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <KeyRound className="mr-2 h-4 w-4" />} Aggiorna password
      </Button>
    </Section>
  );
};
